"use strict";
/*
 * Created on 04 30 2021
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../../core/conversions/DataObjectConverter");
/**
 * @author Jaroslav Sevcik
 */


var SelloutImpactReportDetailRow4BOXDTOConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(SelloutImpactReportDetailRow4BOXDTOConverter, _DataObjectConverter_);

  function SelloutImpactReportDetailRow4BOXDTOConverter() {
    _classCallCheck(this, SelloutImpactReportDetailRow4BOXDTOConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(SelloutImpactReportDetailRow4BOXDTOConverter).apply(this, arguments));
  }

  return SelloutImpactReportDetailRow4BOXDTOConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.SelloutImpactReportDetailRow4BOXDTOConverter = SelloutImpactReportDetailRow4BOXDTOConverter;